import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";
import {addAuthTokenInterceptor, addClientTelemetryInterceptor} from "@/functions/apiInterceptors";

export const triviaClient = axios.create({
    baseURL: `${environmentConfig.triviaServiceV2}/api`,
    withCredentials: true,
});

addAuthTokenInterceptor(triviaClient);
addClientTelemetryInterceptor(triviaClient);
